import { PageBySlug } from "@/features/PageBySlug";
import withData from "@/features/PageBySlug/utils/withData";
import { GetStaticProps, GetStaticPaths } from "next";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { GetPageSlugsDocument, GetPageSlugsQuery } from "@/generated";
import { useRouter } from "next/router";

const LandingPage = (props: any) => {
  const router = useRouter();
  const queryParams = router.query; // Access query params here
  return <PageBySlug {...props} urlParams={queryParams} />;
};

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const data = await withData()(context);
    return data;
  } catch (error: any) {
    return { props: {}, notFound: true };
  }
};

export const getStaticPaths: GetStaticPaths = async () => {
  const client = new ApolloClient({
    uri: `${process.env.NEXT_PUBLIC_API_URL}/graphql`,
    cache: new InMemoryCache(),
  });

  try {
    const { data } = await client.query<GetPageSlugsQuery>({
      query: GetPageSlugsDocument,
      variables: {
        pagination: { limit: 200 },
        filters: {
          target: {
            eq: "landing_page",
          },
          slug: {
            not: {
              startsWith: "app-",
            },
            notNull: true,
          },
        },
      },
    });

    const paths = (data?.pages?.data
      ?.map((page) => ({
        params: {
          slug: [page.attributes?.slug],
        },
      }))
      .filter((page) => page.params.slug[0]) || []) as {
      params: { slug: string[] };
    }[];

    return { paths, fallback: "blocking" };
  } catch (error: any) {
    console.error("Error fetching page slugs:", error);
    return { paths: [], fallback: "blocking" };
  }
};

export default LandingPage;
